import {
  SET_LOGGED_USER,
  GET_ALLOWED_ACTIONS_START,
  GET_ALLOWED_ACTIONS_SUCCESSFULLY,
  GET_ALLOWED_ACTIONS_ERROR,
  GET_LOGGED_IN_USER,
  GET_LOGGED_IN_USER_ERROR,
  GET_LOGGED_IN_USER_START,
} from '../actions/types';

const initialState = {
  loggedUser: {},
  validToken: false,
  allowedActions: {
    loading: false,
    items: [],
    error: undefined,
  },
  loading: false,
  error: undefined,
};

const getAllowedActionsStart = (state) => {
  return {
    ...state,
    allowedActions: {
      loading: true,
      items: [],
      error: undefined,
    },
  };
};

const getAllowedActionsSuccessfully = (state, action) => {
  return {
    ...state,
    allowedActions: {
      loading: false,
      items: action.payload,
      error: undefined,
    },
  };
};

const getAllowedActionsError = (state, action) => {
  return {
    ...state,
    allowedActions: {
      loading: false,
      items: [],
      error: action.payload,
    },
  };
};

const getLoggedInUserStart = (state) => {
  return {
    ...state,
    loading: true,
  };
};

const getLoggedInUserSuccessfully = (state, action) => {
  return {
    ...state,
    loading: false,
    loggedUser: action.payload,
    validToken: true,
    error: undefined,
  };
};

const getLoggedInUserError = (state, action) => {
  return {
    ...state,
    loading: false,
    error: action.payload,
  };
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_LOGGED_USER:
      return {
        ...state,
        loggedUser: action.payload,
      };
    case GET_ALLOWED_ACTIONS_START:
      return getAllowedActionsStart(state);
    case GET_ALLOWED_ACTIONS_SUCCESSFULLY:
      return getAllowedActionsSuccessfully(state, action);
    case GET_ALLOWED_ACTIONS_ERROR:
      return getAllowedActionsError(state, action);

    case GET_LOGGED_IN_USER_START:
      return getLoggedInUserStart(state);
    case GET_LOGGED_IN_USER:
      return getLoggedInUserSuccessfully(state, action);
    case GET_LOGGED_IN_USER_ERROR:
      return getLoggedInUserError(state, action);

    default:
      return state;
  }
}
